export default {
      id: "icon-call-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#icon-call",
      toString: function () {
        return this.url;
      }
    }